import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { GlobalService } from '../../../services/global.service';
import { environment } from '../../../../../environments/environment';
import { Observable, Subject, takeUntil, timer, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomCmsVideoComponent } from '../../../models/cms-links.model'
import { CmsBannerComponentMedia } from '@spartacus/core';

@Component({
  selector: 'app-homepage-video-section4',
  templateUrl: './homepage-video-section4.component.html',
  styleUrl: './homepage-video-section4.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HomepageVideoSection4Component implements OnInit, OnChanges, OnDestroy {

  /** OOTB Implementation */
  public isLoggedIn$: Observable<boolean>;
  @Input() componentData: CustomCmsVideoComponent;
  showPoster = true;
  unsubscribe$ = new Subject<void>();
  videoUrl$: Observable<string>;
  thumbnailUrl$: Observable<string>;
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>

  /** Old Implementation */
  // public componentData: any;
  // videoUrl: string;
  // thumbnailUrl: string;

  constructor(
    public component: CmsComponentData<CustomCmsVideoComponent>,
    private globalService: GlobalService
  ) { }

  /** OOTB Implementation */
  ngOnInit(): void {
    this.isLoggedIn$ = this.globalService.loginBanner$;
  }

  ngOnChanges(): void {
    this.videoUrl$ = of(this.componentData).pipe(
      map(data => environment.siteUrls.getBackofficeUrl + data.video.url)
    );
    this.thumbnailUrl$ = of(this.componentData).pipe(
      map(data => environment.siteUrls.getBackofficeUrl + (data.thumbnail as CmsBannerComponentMedia).url)
    );
  }

  playVideo() {
    this.showPoster = false;
    timer(0)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        const video: HTMLVideoElement = this.videoPlayer.nativeElement;
        video.play().then(() => {
          console.log('Video playback started');
        });
      });
  }

  onVideoEnd() {
    this.showPoster = true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
  }

  /** Old Implementation */
  // ngOnInit(): void {
  //   this.component.data$.subscribe((data) => {
  //     console.log(data, "section4")
  //     this.componentData = data;
  //     this.videoUrl = environment.siteUrls.getBackofficeUrl + data?.video?.url;
  //     this.thumbnailUrl = environment.siteUrls.getBackofficeUrl + data?.thumbnail?.url;
  //     console.log(this.thumbnailUrl, " this.thumbnailUrl")
  //   });
  //   this.isLoggedIn$ = this.globalService.loginBanner$;
  // }
  // playVideo() {
  //   this.showPoster = false;
  //   timer(0)
  //     .pipe(takeUntil(this.unsubscribe$))
  //     .subscribe(data => {
  //       const video: HTMLVideoElement = this.videoPlayer.nativeElement;
  //       video.play().then(() => { });
  //     });
  // }

  // onVideoEnd() {
  //   this.showPoster = true;
  // }

  // ngOnDestroy(): void {
  //   this.unsubscribe$.next(undefined);
  //   this.unsubscribe$.complete();
  // }
}
